export default __webpack_public_path__ + "static/favicon-6ba66bbf35aa1dde5a94a485857e491b.png";